import { useEffect, useState } from "react";
import { useAuth } from "@webapps/reactjs-tech-components";

const HubspotContactForm = ({ region, portalId, formId, type }) => {
  const { email } = useAuth();

  const [formCreated, setFormCreated] = useState(false);

  useEffect(() => {
    const initializeForm = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: region,
          portalId: portalId,
          formId: formId,
          target: '#hubspotForm',
          onFormReady: setFormCreated(true),
        });
      }
    };

    const loadFormScript = () => {
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/shell.js';
      script.async = true;
      document.body.appendChild(script);

      script.addEventListener('load', initializeForm);
    };

    loadFormScript();
  }, []);

  useEffect(() => {
    if (formCreated) {
      const inputs = document.querySelectorAll('input');
      inputs.forEach((input) => {
        console.log(input);
      });
    }
  }, [formCreated]);

  return (
    <div id="hubspotForm"></div>
  );
};

export default HubspotContactForm;
